import React from 'react';
import './TotalHeader.scss';

import { FlightTooltip, getIcon } from '@flybits/design-system';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const MAIN_CLASS = 'analytics-table';
const CLASSES = {
  TOTALS: `${MAIN_CLASS}__totals`,
  TOTAL_ITEM: `${MAIN_CLASS}__totals__item`,
  TOTAL_ITEM_TOOLTIP: `${MAIN_CLASS}__totals__item__tooltip`,
};

interface TotalsDataProps {
  headers: string[];
  values: string[];
  isLoading: boolean;
  // Tooltip descriptions keyed by header label, so it is clear which metric each tooltip belongs to.
  tooltips?: Record<string, string>;
}

const TotalHeader: React.FC<TotalsDataProps> = ({ headers, values, isLoading, tooltips }) => {
  return (
    <div className={CLASSES.TOTALS}>
      {headers.map((header, index) => {
        const tooltip = tooltips?.[header];
        return (
          <div key={header} className={CLASSES.TOTAL_ITEM}>
            <h4>
              {header}
              {tooltip ? (
                <FlightTooltip
                  className={CLASSES.TOTAL_ITEM_TOOLTIP}
                  description={tooltip}
                  direction="top"
                  maxWidth="240px"
                >
                  {getIcon('infoStroke', { width: '14px', height: '14px', fill: '#82899b' })}
                </FlightTooltip>
              ) : null}
            </h4>
            {!isLoading ? values[index] || 'N/A' : <Skeleton width={40} height={24} />}
          </div>
        );
      })}
    </div>
  );
};

export default TotalHeader;
